module.exports = __webpack_public_path__ + "static/media/Group 10386.f18e2c19.svg";